import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border-top: 1px solid ${(p) => p.theme.palette.primary[100]};
`;
